/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
// import { Logger } from "cms/utils/log/logger";

const CTAImage = (props) => {

    const { image: _image, imageCard } = props || {};
    const { token } = useAuth();
    const [image, setImage] = useState();
    const isVertical = imageCard === "vertical";
    const direction = isVertical ? "vertical" : "horizontal";

    useEffect(() => {
        const load = async () => {
            // Logger.info('load image', _image)
            if (!image) {
                if (_image) {
                    const img = await SimpliCityAdminSDK.images.findOne(token, _image);
                    setImage(img);
                }
            }
        };
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {image &&
                <div
                    title={image?.alt}
                    className={`simplicity-cta-content-image ${direction}`}
                    style={{
                        backgroundImage: `url(${image?.url})`,
                        // backgroundPosition: 'top right',
                        backgroundPosition: "center center",
                    }}
                >
                </div>
            }
        </>
    );
};

export { CTAImage };
